import { render, staticRenderFns } from "./ResumePhoto.vue?vue&type=template&id=c2c7afd6&scoped=true&"
import script from "./ResumePhoto.vue?vue&type=script&lang=js&"
export * from "./ResumePhoto.vue?vue&type=script&lang=js&"
import style0 from "./ResumePhoto.vue?vue&type=style&index=0&id=c2c7afd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_prettier@3.0.3_vue-template-compiler@2.6.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c7afd6",
  null
  
)

export default component.exports